import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CutsceneTemplat from '../Components/Layout/CutsceneTemplate';

import Commander from '../Assets/Imgs/Commander.png';
import Mike from '../Assets/Imgs/Mike.png';
import Btn from '../Components/Common/Btn';
import BGSong from '../Assets/Sounds/seventeensplitcfg.wav';
import BGMusic from '../Components/Common/BackgroundMusic';

import Pause from '../Assets/Icons/Pause.svg'
import PauseMenu from '../Components/Layout/PauseMenu';


const ApproachCutscene = (musicVolume, setMusicVolume) => {

    const [currentLine, setCurrentLine] = useState(0)
    const [isPaused, setIsPaused] = useState(false);

    const navigate = useNavigate();

    const dialogue = [
        {
            img: Commander, text: 'You’re coming up on the bridge of the station now, taking back control isn’t going to be easy', DName: 'Commander'
        },
        {
            img: Commander, text: 'The cockpit’s security measures have been activated so i’d avoid getting anywhere near the floor.', DName: 'Commander'
        },
        {
            img: Commander, text: 'On top of that, the bridge to the control center has gone haywire!', DName: 'Commander'
        },
        {
            img: Commander, text: 'Get across that bridge and you should have an easy way to get to the command center', DName: 'Commander'
        },
        {
            img: Mike, text: 'Roger That', DName: 'Private Mike'
        }

    ]

    const handleNextDialogue = () => {
        if (currentLine < dialogue.length - 1) {
            setCurrentLine(prevStep => prevStep + 1);
        } else {
            navigate('/L3');
        }
    };

    const currentDialogue = dialogue[currentLine];
    console.log(dialogue[0])

    return ( 
        <main className='IntroCutsceneMain'>

            <BGMusic 
                src={BGSong} 
                volume={musicVolume / 100} 
                isPlaying={true} 
            />

            <Btn BtnIcon={Pause} BtnStyle="PauseBtn" onClick={() => setIsPaused(true)}/>
            
            <CutsceneTemplat TemplateClass='ApproachTemplate' DialogueImg={currentDialogue.img} DialogueName={currentDialogue.DName} DialogueP={currentDialogue.text} NextBtnChange={handleNextDialogue}/>

            {isPaused && <PauseMenu ResumeClick={()=>setIsPaused(false)}/>}
        </main>
     );
}
 
export default ApproachCutscene;